import React from "react";
import { Col } from "react-bootstrap";
import "./style.scss";
import { UpperRow } from "../../../library/upper-row";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import ComposeEmailContainer from "./compose-email";
import ComposeSMSContainer from "./compose-sms";
import { useSelector } from "react-redux";

const Index = () => {
  const content = EditorState.createEmpty();
  const details = useSelector((state) => state.singleTemplate.details);

  const selectionTabs = [
    {
      key: "email",
      title: "E-post",
      content: <ComposeEmailContainer />,
      disabled: details.type !== "email",
    },
    {
      key: "sms",
      title: "SMS",
      content: <ComposeSMSContainer />,
      disabled: details.type !== "sms",
    },
  ];

  const handleEditorChange = (state) => {
    //convertContentToHTML(state);
  };

  return (
    <Col md={7} className="dashboard-single-template-left-container">
      <Col className="inner-dashboard-single-template-left-container">
        <UpperRow title="Utforming" />
        {details.type === "email" ? (
          <ComposeEmailContainer />
        ) : (
          <ComposeSMSContainer />
        )}
      </Col>
    </Col>
  );
};

export default Index;
